import { ReactNode } from "react";

type Props = {
  isShow: boolean;
  handleClose: () => void;
  children: ReactNode;
  headerBody?: ReactNode;
  footerBody?: ReactNode;
};

export const ModalWrapper = ({ handleClose, children, isShow, headerBody, footerBody }: Props) => {
  if (!isShow) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm"
      onClick={handleClose}
    >
      <div
        className="bg-white rounded-lg shadow-lg w-full max-w-lg mx-4 relative animate-fade-in"
        onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside modal
      >
        {/* Header */}
        {(headerBody || true) && (
          <div className="flex items-center justify-between border-b px-4 py-3">
            {headerBody && <h3 className="text-lg font-semibold">{headerBody}</h3>}
            <button
              type="button"
              aria-label="Close modal"
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-600 text-xl font-bold"
            >
              &times;
            </button>
          </div>
        )}

        {/* Body */}
        <div className="p-4">{children}</div>

        {/* Footer */}
        {footerBody && <div className="border-t px-4 py-3">{footerBody}</div>}
      </div>
    </div>
  );
};
